<template>
	<div id="app">
		<!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <router-view />
	</div>
</template>

<script>
	export default {
		name: 'app',
		mounted() {
			// 确保页面加载完成后字体设置正确
			this.ensureMicrosoftYaHeiFont();
			
			// 监听路由变化，确保每个页面都使用正确字体
			this.$router.afterEach(() => {
				this.$nextTick(() => {
					this.ensureMicrosoftYaHeiFont();
				});
			});
		},
		methods: {
			ensureMicrosoftYaHeiFont() {
				const fontFamily = '"Microsoft YaHei", "微软雅黑", "MS YaHei", "SimHei", Arial, sans-serif';
				
				// 设置body和html字体
				document.documentElement.style.fontFamily = fontFamily;
				document.body.style.fontFamily = fontFamily;
				
				// 查找所有可能的元素并设置字体
				const elements = document.querySelectorAll('*');
				elements.forEach(el => {
					el.style.fontFamily = fontFamily;
				});
				
				// 特别处理Element UI组件
				setTimeout(() => {
					const elComponents = document.querySelectorAll(`
						.el-input__inner, .el-textarea__inner, .el-select, .el-button,
						.el-menu, .el-table, .el-form-item__label, .el-dialog,
						.el-message, .el-notification, .el-dropdown-menu, .el-tooltip
					`);
					elComponents.forEach(el => {
						el.style.fontFamily = fontFamily;
					});
				}, 100);
			}
		}
	}
</script>

<style>
#app {
  font-family: "Microsoft YaHei", "微软雅黑", "MS YaHei", "SimHei", Arial, sans-serif !important;
}

/* 全局强制微软雅黑字体 */
* {
  font-family: "Microsoft YaHei", "微软雅黑", "MS YaHei", "SimHei", Arial, sans-serif !important;
}

/* 360浏览器兼容模式特殊处理 */
.ua-360 * {
  font-family: "Microsoft YaHei", "微软雅黑", "MS YaHei", "SimHei", Arial, sans-serif !important;
}

/* IE浏览器特殊处理 */
.ua-ie * {
  font-family: "Microsoft YaHei", "微软雅黑", "MS YaHei", "SimHei", Arial, sans-serif !important;
}
</style>